.waveContainer {
  display: flex;
  max-height: 150px;
  flex: 1;
  margin-bottom: 2px;
}

.peaksPlaceholder {
  display: block;
  padding: 0 8px;
  position: absolute;
  top: 32px;
  z-index: 1;
  background-color: var(--tuna-palette-secondary-light);
  color: var(--tuna-palette-secondary-contrastText);
}

.rangeOverlay {
  height: 4px;
  width: 100%;
  display: flex;
}

.fabs {
  flex-direction: column;
  align-items: space-between;
}

.recorderFab {
  margin-top: 8px;
}

.fab {
  position: absolute;
  left: calc(50% - 28px);
  right: 8px;
  z-index: 100;
  display: none;
}

.fab--visible {
  display: flex;
}

.controls {
  width: 100%;
  position: absolute;
  display: none;
  align-items: center;
  top: 0;
  right: 0;
  z-index: 1300;
  opacity: 0.9;
}
